export class CostReviewElectricalWiring {
  electricalSubcontractor!: string;
  amountBudgeted!: number;
  threeBidsSecured!: number;
  requestedQuotesFrom!: string;
  fpmInvolved!: number;
  quoteVariance!: number;
  receivedBindingQuote!: number;
  subIsBauCertified!: number;
  subHasProjectSpecifications!: number;
  subHasCapacityToCompleteWork!: number;
  subCarriesBond!: number;
  contractValue!: number;
  wiringType!: number;
  allConduitRequired!: number;
  minimumConduitSize!: number;
  safetiesFurnishedBy!: string;
  isElectricalWiringApplicable!: boolean;
  subCarriesBondReason!: string;
  conduitType!: number;
  contractorSubcontractorHasDPU!: number;
  subCarriesBondSelection!: boolean;
  ifNoWillOneBeProvided!: number;
  vendorNameBidOne!: string;
  vendorNameBidTwo!: string;
  vendorNameBidThree!: string;
  securityPMInvolved!: number;
  subsNotifiedSecurity!: number;
  fiberOpticsSecurity!: number;
}
